const Provider = require("./Provider");
const PropTypes = require("prop-types");

class Prefix extends Provider {

    componentDidUpdate(prevProps) {
        if (prevProps.prefix !== this.props.prefix) {
            this.prefix = this.props.prefix;
            this.updateUuid();
        }
    }

    /////////////////////////////////
    // Statics
    /////////////////////////////////

    static get propTypes() {
        return {
            prefix: PropTypes.any
        };
    }

    static get defaultProps() {
        return {
            prefix: {}
        };
    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    resolvePrefix() {
        return this.props.prefix;
    }

    get providerProps() {
        return {
            prefix: this.resolvePrefix()
        };
    }

}

module.exports = Prefix;